import Http from './http';
import store from 'store';

class ClientTaxonomiesService {
    constructor() {
        this.clientTaxonomies = null;
        this.flatTaxonomies = null;
        // store.set('clientTaxonomies', false);
        // store.set('flatTaxonomies', false);
    }

    resetCache() {
        store.set('clientTaxonomies', false);
        store.set('flatTaxonomies', false);
        this.clientTaxonomies = null;
        this.flatTaxonomies = null;
        this.getClientTaxonomies();
    }

    recurseTaxonomies(current, root = '', colour = '#dddddd') {
        let return_object = {}
        if ( current.colour ) {
            colour = current.colour;
        }

        if (colour.length === 4) {
            let temp_colour = '#';
            colour.map(x => {
                temp_colour += x + x;
            })
            colour = temp_colour;
        }
        if (colour.length === 7) colour = colour + '50';
        
        current.children.map(taxonomy => {
            return_object[taxonomy.id] = {"label":root + taxonomy.name, "colour":  taxonomy.colour || colour, 'name':taxonomy.name}
            return_object = { ...return_object, ...this.recurseTaxonomies(taxonomy, root + taxonomy.name + ' > ', colour) }
        })
        
        return return_object
    }

    getClientTaxonomies() {
        return new Promise((resolve, reject) => {
            if (store.get('clientTaxonomies', false)) {
                this.clientTaxonomies = store.get('clientTaxonomies');
                this.flatTaxonomies = store.get('flatTaxonomies');
            }
            if (this.clientTaxonomies && this.flatTaxonomies) {
                resolve({ clientTaxonomies: this.clientTaxonomies, flatTaxonomies: this.flatTaxonomies });
            }
            else {
                Http.get('/client_taxonomies/?full=true').then(resp => {
                    this.clientTaxonomies = { 
                        'children': resp.data.client_taxonomies, 
                        'name': 'Client Taxonomies', 
                        'id': 'ClientTaxonomies', 
                        'original_name': 'Client Taxonomies', 
                        'riskfusionref': 'ClientTaxonomies' 
                    };

                    store.set('clientTaxonomies', this.clientTaxonomies);
                    this.flatTaxonomies = this.recurseTaxonomies(this.clientTaxonomies)
                    store.set('flatTaxonomies', this.flatTaxonomies);
                    resolve({ clientTaxonomies: this.clientTaxonomies, flatTaxonomies: this.flatTaxonomies });
                });
            }
        })
    }
}

export default new ClientTaxonomiesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/client-taxonomies.js